import { Dialog, Typography, Grow  } from '@mui/material';
import React from 'react';

const MainDialogBox = ({ open, handleClose, children, width, heading }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth={false}
            sx={{ bgcolor: "transparent", boxShadow: "none", overflow: "hidden" }}
            slots={{ transition: Grow }}
            slotProps={{
                paper: {
                    sx: {
                        bgcolor: "#fff",
                        boxShadow: "none",
                        width: { lg: width || "80%", xs: "100%" },
                        maxWidth: { lg: width || "80%", xs: "100%" },
                        borderRadius: "10px",
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                        maxHeight: "80vh",
                        p: { xs: "10px 15px", sm: "31px 46px" }
                    }
                }
            }}
        >
            <Typography variant='h5' fontWeight={500} mb={2}>{heading}</Typography>
            {children}


        </Dialog>
    );
};

export default MainDialogBox;
